let userEventFired = false;
let loadEventFired = false;

function interactionHandler() {
    userEventFired = true;
    loadEventFired && dispatchEventFirstInteraction();
    eachEventType(window.removeEventListener, interactionHandler);
}

function loadHandler() {
    loadEventFired = true;
    userEventFired && dispatchEventFirstInteraction();
}

function dispatchEventFirstInteraction() {
    const event = document.createEvent('CustomEvent');
    event.initCustomEvent('firstInteraction', false, false, null);

    if ('requestIdleCallback' in window) {
        window.requestIdleCallback(() => window.dispatchEvent(event));
    } else {
        window.dispatchEvent(event);
    }
}

function eachEventType(listener, callback) {
    const listenerOpts = { passive: true, capture: true };
    const eventsTypes = [
        'mousedown',
        'scroll',
        'keydown',
        'touchstart',
        'pointerdown'
    ];

    eventsTypes.forEach(eventType => {
        listener(eventType, callback, listenerOpts);
    });
}

eachEventType(window.addEventListener, interactionHandler);
window.addEventListener('load', loadHandler);

